import SoftTokensActivateTokenRegisterCodePage from "components/pages/SoftTokensActivateTokenRegisterCodePage";
/**
 * @name CaptureSoftTokenActivationActivateToken
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateToken(props) {
    return <SoftTokensActivateTokenRegisterCodePage />;
}